// extracted by mini-css-extract-plugin
module.exports = {"title":"VideoList_title__2UFDP","videoListItem":"VideoList_videoListItem__fwG60"};